const passwordPageLogout = (() => {
	const trigger = document.querySelector("[data-cookie-name]");

	const init = () => {
		if (!trigger) return

		trigger.addEventListener("click", (e) => onClickLogoutTrigger(e));
	};

	const onClickLogoutTrigger = (e) => {
		e.preventDefault();

		let request = new XMLHttpRequest();
		request.onreadystatechange = function () {
			if (request.status >= 200 && request.status < 300) {
				location.reload();
			} else {
				console.log(request.response);
			}
		};
		request.open("POST", "/wp-admin/admin-ajax.php", true);

		const fd = new FormData();
		fd.append('action', 'update_cookie');
		fd.append('name', trigger.dataset.cookieName);

		request.send(fd);
	};

	return {
		init: init
	};
})();

export {passwordPageLogout};
